import React, { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { Close } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { Dialog, DialogContent, withWidth } from "@material-ui/core";
import { first } from "lodash";
import { RiFullscreenLine } from "react-icons/ri";
import CampaignModalTab from "./CampaignModalTab";

const useStyles = makeStyles(theme => ({
  featuredImageTabs: {
    backgroundColor: "#ffffff",
    zIndex: "5",
    boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.25)",
    borderRadius: "6px",
    maxHeight: "calc(100% - 64px) !important",
    maxWidth: "750px",
    width: "100%",
    overflowY: "auto",
    padding: 0,
    paddingTop: "0 !important",
  },
  featuredImageTabsHeading: {
    fontSize: "22px",
    color: "#fff",
    padding: "15px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#3699FF",
    marginTop: "0",
  },
  userNote: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#eb5757",
    position: "absolute",
    bottom: "70px",
    zIndex: 999,
    left: "20px",
  },
  fieldsOption: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    marginTop: "4px",
  },
}));

export const MarketingModal = ({
  open,
  setOpen,
  setLoading,
  loadAllCampaigns,
  isSupportInbox,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isMaximise, setIsMaximise] = useState(false);

  const headingModle = () => {
    if (open === true) {
      return "New Campaign";
    } else if (
      open?.platform === "Facebook" ||
      open?.platform === "Instagram"
    ) {
      return "Messages";
    } else {
      return "Email";
    }
  };
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      className={`${isMaximise ? "maximiseScreen" : ""} marketingPopupWrapper`}>
      <DialogContent className={classes.featuredImageTabs}>
        <h2 className={classes.featuredImageTabsHeading}>
          {headingModle()}

          <span>
            <RiFullscreenLine
              style={{
                cursor: "pointer",
              }}
              className={classes.closeTabs}
              onClick={() => setIsMaximise(!isMaximise)}
            />
            <Close
              style={{
                cursor: "pointer",
              }}
              className={classes.closeTabs}
              onClick={() => setOpen(false)}
            />
          </span>
        </h2>
        <CampaignModalTab
          open={open}
          setOpen={setOpen}
          setLoading={setLoading}
          loadAllCampaigns={loadAllCampaigns}
          isSupportInbox={isSupportInbox}
        />
      </DialogContent>
    </Dialog>
  );
};
